"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.acceptConditions = acceptConditions;
exports.addFavorite = addFavorite;
exports.removeFavorite = removeFavorite;
exports.addRecent = addRecent;
exports.setScrollState = setScrollState;
exports.skipPromo = skipPromo;
exports.setMedia = setMedia;
exports.setRatings = setRatings;
exports.goOnline = goOnline;
exports.goOffline = goOffline;

var _ = require("./");
/**
 * Accept terms and condition
 *
 * @returns {{type}}
 */


function acceptConditions() {
  return {
    type: _.ACCEPT_CONDITIONS
  };
}
/**
 * Add item to favorites
 *
 * @param {String} year Model year
 * @param {String} model Model name
 * @param {String} topic Topic id
 * @param {String} [brand] model brand
 * @param {String} [productType] model product type
 * @param {String} [productSubtype] model product subtype
 * @returns {{type, payload: *}}
 */


function addFavorite(year, model, topic) {
  var brand = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var productType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var productSubtype = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  return {
    type: _.ADD_FAVORITE,
    payload: {
      year: year,
      model: model,
      topic: topic,
      brand: brand,
      productType: productType,
      productSubtype: productSubtype
    }
  };
}
/**
 * Remove items from favorites
 *
 * @param {String} year Model year
 * @param {String} model Model name
 * @param {String} topic Topic id
 * @param {String} [brand] model brand
 * @param {String} [productType] model product type
 * @param {String} [productSubtype] model product subtype
 * @returns {{type, payload: *}}
 */


function removeFavorite(year, model, topic) {
  var brand = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var productType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var productSubtype = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  return {
    type: _.REMOVE_FAVORITE,
    payload: {
      year: year,
      model: model,
      topic: topic,
      brand: brand,
      productType: productType,
      productSubtype: productSubtype
    }
  };
}
/**
 * Add item to recently viewed (FILO)
 *
 * @param {String} year Model year
 * @param {String} model Model name
 * @param {String} topic Topic id
 * @param {String} [brand] model brand
 * @param {String} [productType] model product type
 * @param {String} [productSubtype] model product subtype
 * @returns {{type, payload: *}}
 */


function addRecent(year, model, topic) {
  var brand = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var productType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var productSubtype = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  return {
    type: _.ADD_RECENT,
    payload: {
      year: year,
      model: model,
      topic: topic,
      brand: brand,
      productType: productType,
      productSubtype: productSubtype
    }
  };
}
/**
 * Remembers scroll state for certain URL
 *
 * TODO: when scroll state is getting cleaned?
 *
 * @param {number} scrollTop
 * @param {String} scrollUrl
 * @returns {{type, payload: {scrollTop: *, scrollUrl: *}}}
 */


function setScrollState(scrollTop, scrollUrl) {
  return {
    type: _.SET_SCROLL_STATE,
    payload: {
      scrollTop: scrollTop,
      scrollUrl: scrollUrl
    }
  };
}
/**
 * Skips promo screen
 *
 * @returns {{type, payload: boolean}}
 */


function skipPromo() {
  return {
    type: _.SKIP_PROMO
  };
}
/**
 * Set media state (device, orientation etc.)
 *
 * @param {object} media state
 * @returns {{type, payload: object}}
 */


function setMedia(media) {
  return {
    type: _.SET_MEDIA_STATE,
    payload: media
  };
}
/**
 * Sets user rating on topic
 *
 * @param {String} year Model year
 * @param {String} model Model name
 * @param {String} topic Topic id
 * @param {String} rating Rating value
 * @returns {{type, payload: object}}
 */


function setRatings(year, model, topic, rating) {
  return {
    type: _.SET_RATINGS,
    payload: {
      year: year,
      model: model,
      topic: topic,
      rating: rating
    }
  };
}
/**
 * User's device went online
 *
 * @returns {{type}}
 */


function goOnline() {
  return {
    type: _.NETWORK_ONLINE
  };
}
/**
 * User's device went offline
 *
 * @returns {{type}}
 */


function goOffline() {
  return {
    type: _.NETWORK_OFFLINE
  };
}